export default __webpack_public_path__ + "static/media/kuulolaitehuolto-lightblue.22c1dc59.svg";